import React from 'react';
import { ScrollView, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Toggle from '../../../../components/Toggle';
import Header from '../../../../navigation/Header';
import useCommunitySettings from '../../../../hooks/useCommunitySettings';


function SwitchCard({ title, description, value, onValueChange, disabled }) {
  return (
    <View style={tw`bg-white rounded-2xl border border-gray-200 px-4 py-4 mb-3`}>
      <View style={tw`row items-center justify-between mb-2`}>
        <Text style={tw`text-secondary font-600 text-base flex-1 mr-3`}>{title}</Text>
        <Toggle value={value} onValueChange={onValueChange} disabled={disabled} />
      </View>
      <Text style={tw`text-gray-500 text-sm`}>{description}</Text>
    </View>
  )
}


export default function ReportsSettingsScreen() {
  const { updateSettings, getSettingValue, isUpdating } = useCommunitySettings()

  return (
    <View style={tw`flex-1 bg-[#F3F2F3]`}>
      <Header showBackButton title="Reportes y solicitudes" style="bg-transparent" />

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-4 pt-4 pb-10`}>
        <SwitchCard
          title="Reportes y solicitudes"
          description="Los vigilantes pueden reportar incidencias desde su aplicación con chat directo en la aplicación."
          value={getSettingValue('tickets.guard_reports_enabled', true)}
          onValueChange={(value) => updateSettings('tickets.guard_reports_enabled', value)}
          disabled={isUpdating}
        />

        <SwitchCard
          title="Reportes de residentes"
          description="Los residentes también pueden enviar solicitudes y reportes a la administración."
          value={getSettingValue('tickets.resident_reports_enabled', true)}
          onValueChange={(value) => updateSettings('tickets.resident_reports_enabled', value)}
          disabled={isUpdating}
        />

        <SwitchCard
          title="Residentes eligen categoría"
          description="Al reportar, el residente elige la categoría y el reporte se asigna al área que tenga por default. Solo aplica si hay categorías creadas."
          value={getSettingValue('tickets.resident_categories_enabled', false)}
          onValueChange={(value) => updateSettings('tickets.resident_categories_enabled', value)}
          disabled={isUpdating}
        />
      </ScrollView>
    </View>
  );
}
